import router from './router';
import store from './store';
import { getToken } from 'assets/js/auth';
import WaterMark from '@/assets/js/watermark.js';
import moment from 'moment';
const whiteList = ['/login']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken();
  const hasInfo = !!store.getters.portfolioInfo;
  if (hasToken && hasInfo) {
    WaterMark.set(
      store.getters.portfolioInfo.portfolioName +
        ' ' +
        moment().format('YYYY-MM-DD')
    );
    next();
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/login');
    }
  }
});
